/** Mirrors portal Feeds defaults and the 100 MB cap. This widget does not narrow them. */
export const ATTACHMENT_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;

export const ATTACHMENT_ALLOWED_MIME_TYPES = Object.freeze([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'video/mp4',
  'video/webm',
  'audio/mpeg',
  'audio/mp3',
  'application/pdf',
]);

export const ATTACHMENT_ACCEPT = ATTACHMENT_ALLOWED_MIME_TYPES.join(',');

export const ATTACHMENT_INSTANCE_TYPE = 'case_plan_widget';

export const ATTACHMENT_ITEM_STATUS = {
  SUCCESS: 'success',
  UPLOADING: 'uploading',
  ERROR: 'error',
};

export const ATTACHMENT_VALIDATION_MESSAGES = {
  EMPTY: 'File is empty.',
  SIZE: 'File size is too large and exceeds the 100 MB limit',
  TYPE: 'This file type is not supported. Use MP3, MP4, WebM, JPG, PNG, GIF, SVG, or PDF formats to upload.',
  MAX_FILES: 'This widget already has the maximum number of attachments.',
  UPLOAD: 'Upload failed.',
};

export const ATTACHMENT_ACTION_ERROR_MESSAGES = {
  REMOVE: 'Failed to remove the attachment. Please try again.',
  OPEN: 'Failed to open the attachment. Please try again.',
};
